import Container from 'components/UI/Container';
import React from 'react';
import './HomeHeader.module.scss';
import Button from 'components/UI/Button';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export default function HomeHeader() {
    // const [videoPopupOpen, setVideoPopupOpen] = useState(false);
    const history = useHistory();
    return (
        <>
            <Container
                home
                color="purple"
                // image="/images/background-head-home.svg"
            >
                <div styleName="head-home ">
                    <div styleName="text">
                        <h1>Grijp je kans in het onderwijs</h1>
                        {/* <p>
                            Sta je aan de start van je loopbaan? Overweeg je een
                            overstap naar het onderwijs? Of wil je je huidige
                            baan combineren met het geven van onderwijs? Kansen
                            zijn er genoeg binnen ons netwerk in het oosten van
                            Brabant. Het is aan jou om ze te grijpen.
                        </p> */}
                        {/* <Button
                            onClick={() => {
                                history.push('/test');
                            }}
                            color="yellow"
                            icon={faArrowRight}
                        >
                            Start de test
                        </Button> */}
                    </div>
                    <div styleName="image-wrapper">
                        <img
                            src="/images/climber-head-home.svg"
                            alt="climber head"
                        />
                    </div>
                </div>
            </Container>
            {/* {videoPopupOpen && (
                <Modal
                    closeModal={() => {
                        setVideoPopupOpen(false);
                    }}
                >
                    <Video video="TQEbi-mrGec" videoType="youtube" />
                </Modal>
            )} */}
        </>
    );
}
